import * as actions from './actions'

const initState = {
    adminLocations: null,
    locations: null,
    selectedHotSwapLocations: [],
    hotSwap: null,
    isLoading: null
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.HOTSWAP_GET_LOCATIONS_REQUEST:
            return {
                ...state,
                ...{
                    isLoading: true
                }
            }
        case actions.HOTSWAP_GET_LOCATIONS_SUCCESS:
            return {
                ...state,
                ...{
                    locations: action.locations,
                    isLoading: false
                }
            }
        case actions.HOTSWAP_GET_LOCATIONS_ERROR:
            return {
                ...state,
                ...{
                    isLoading: false
                }
            }
        case actions.HOTSWAP_GET_LOCATIONS_ADMIN_REQUEST:
            return {
                ...state,
                ...{
                    isLoading: true
                }
            }
        case actions.HOTSWAP_GET_LOCATIONS_ADMIN_SUCCESS:
            return {
                ...state,
                ...{
                    adminLocations: action.locations,
                    isLoading: false
                }
            }
        case actions.HOTSWAP_GET_LOCATIONS_ADMIN_ERROR:
            return {
                ...state,
                ...{
                    isLoading: false
                }
            }
        case actions.HOTSWAP_GET_BY_ID_REQUEST:
            return {
                ...state,
                ...{
                    isLoading: true
                }
            }
        case actions.HOTSWAP_GET_BY_ID_SUCCESS:
            return {
                ...state,
                ...{
                    hotSwap: action.hotswap,
                    isLoading: false
                }
            }
        case actions.HOTSWAP_GET_BY_ID_ERROR:
            return {
                ...state,
                ...{
                    isLoading: false
                }
            }
        case actions.HOTSWAP_UPDATE_SUCCESS:
            return {
                ...state,
                ...{
                    hotSwap: { ...state.hotSwap, ...action.updatedHotswap }
                }
            }
        case actions.SET_SELECTED_HOTSWAP_LOCATIONS: {
            return {
                ...state,
                selectedHotSwapLocations: action.response
            }
        }
        default:
            return state
    }
}
